<section class="vc-admin-customer-signup">
  <button type="button" class="vc-admin-customer-signup__launcher" (click)="openWizard()">
    <span class="vc-admin-customer-signup__launcher-icon">
      <i class="pi pi-plus-circle"></i>
    </span>
    <span class="vc-admin-customer-signup__launcher-copy">
      <strong>{{ "ADMIN.CUSTOMERS.ADD" | translate }}</strong>
      <small>{{ "ADMIN.CUSTOMERS.WIZARD.DESCRIPTION" | translate }}</small>
    </span>
  </button>

  <p-dialog [(visible)]="wizardVisible" [modal]="true" [draggable]="false" [resizable]="false"
    [style]="{ width: '66rem', maxWidth: '95vw' }" [contentStyle]="{ overflow: 'auto', maxHeight: '74vh' }"
    [header]="'ADMIN.CUSTOMERS.WIZARD.TITLE' | translate" [closable]="!submitting" [closeOnEscape]="!submitting"
    [dismissableMask]="!submitting" (onHide)="closeWizard()">
    <form id="customerWizardForm" class="form vc-admin-customer-signup__form" [formGroup]="form" (ngSubmit)="execute()"
      novalidate>
      <p class="vc-admin-customer-signup__description">
        {{ "ADMIN.CUSTOMERS.WIZARD.DESCRIPTION" | translate }}
      </p>

      <div class="vc-admin-customer-signup__progress">
        <div class="vc-admin-customer-signup__progress-bar">
          <span [style.width.%]="progressPercentage"></span>
        </div>
        <div class="vc-admin-customer-signup__steps">
          @for (step of [1, 2, 3, 4, 5]; track step) {
          <button type="button" class="vc-admin-customer-signup__step" [class.is-active]="currentStep === step"
            [class.is-done]="currentStep > step" (click)="currentStep = step">
            <span>{{ step }}</span>
            <small>{{ stepKey(step) | translate }}</small>
          </button>
          }
        </div>
      </div>

      @if (currentStep === 1) {
      <section class="vc-admin-customer-signup__panel" formGroupName="customer">
        <h4>{{ "ADMIN.CUSTOMERS.WIZARD.STEP_1" | translate }}</h4>
        <div class="grid vc-admin-customer-signup__compact-grid">
          <div class="field col-12 lg:col-5">
            <label for="customerName">{{ "ADMIN.CUSTOMERS.NAME" | translate }} *</label>
            <input id="customerName" pInputText formControlName="name" />
          </div>
          <div class="field col-12 lg:col-3">
            <label for="customerCurrency">{{ "COMMON.CURRENCY" | translate }} *</label>
            <p-select inputId="customerCurrency" [options]="currencies" formControlName="currency" optionLabel="name"
              optionValue="code" [showClear]="false"></p-select>
          </div>
          <div class="field col-12 lg:col-4">
            <label for="customerIdentifier">{{ "ADMIN.CUSTOMERS.WIZARD.IDENTIFIER" | translate }} *</label>
            <input id="customerIdentifier" pInputText formControlName="identifier" />
            @if (getIdentifierStatusKey()) {
            <small class="vc-admin-customer-signup__identifier-status" [class.is-ok]="identifierStatus === 'available'"
              [class.is-error]="
                    identifierStatus === 'taken' ||
                    identifierStatus === 'invalid'
                  ">
              {{ getIdentifierStatusKey() | translate }}
            </small>
            }
            @if (identifierSuggestion) {
            <button type="button" class="vc-admin-customer-signup__suggestion" (click)="useSuggestedIdentifier()">
              {{
              "ADMIN.CUSTOMERS.WIZARD.USE_SUGGESTION"
              | translate: { value: identifierSuggestion }
              }}
            </button>
            }
          </div>
          <div class="field col-12 lg:col-8">
            <label for="customerBusinessCategories">{{ "ADMIN.BUSINESS_CATEGORIES.FIELD" | translate }} *</label>
            <p-multiSelect inputId="customerBusinessCategories" formControlName="business_category_ids"
              [options]="businessCategories" optionLabel="displayName" optionValue="id" [showToggleAll]="true"
              [filter]="true" [filterBy]="'displayName'" [placeholder]="'ADMIN.BUSINESS_CATEGORIES.SELECT' | translate"
              [selectedItemsLabel]="
                  'ADMIN.BUSINESS_CATEGORIES.SELECTED' | translate
                " display="chip" styleClass="w-full" appendTo="body"></p-multiSelect>
          </div>
        </div>
      </section>
      }

      @if (currentStep === 2) {
      <section class="vc-admin-customer-signup__panel" formGroupName="contact">
        <h4>{{ "ADMIN.CUSTOMERS.WIZARD.STEP_2" | translate }}</h4>
        <div class="grid vc-admin-customer-signup__compact-grid">
          <div class="field col-12 lg:col-4">
            <label for="contactEmail">{{ "COMMON.EMAIL" | translate }} *</label>
            <input id="contactEmail" pInputText formControlName="email" />
          </div>
          <div class="field col-12 lg:col-3">
            <label for="contactPhone">{{ "COMMON.PHONE" | translate }} *</label>
            <input id="contactPhone" pInputText formControlName="phone" />
          </div>
          <div class="field col-12 lg:col-3">
            <label for="contactName">{{
              "ADMIN.CUSTOMERS.FISCAL.CONTACT_NAME" | translate
              }}</label>
            <input id="contactName" pInputText formControlName="contact_name" />
          </div>
          <div class="field col-12 lg:col-8">
            <label for="contactPostalAddress">{{
              "COMMON.ADDRESS" | translate
              }}</label>
            <input id="contactPostalAddress" pInputText formControlName="postal_address" />
          </div>
        </div>
      </section>
      }

      @if (currentStep === 3) {
      <section class="vc-admin-customer-signup__panel" formGroupName="billing">
        <h4>{{ "ADMIN.CUSTOMERS.WIZARD.STEP_3" | translate }}</h4>
        <div class="grid vc-admin-customer-signup__compact-grid">
          <div class="field col-12 lg:col-4">
            <label for="legalName">{{ "ADMIN.CUSTOMERS.FISCAL.LEGAL_NAME" | translate }} *</label><input id="legalName"
              pInputText formControlName="legal_name" />
          </div>
          <div class="field col-12 lg:col-3">
            <label for="fiscalId">{{ "ADMIN.CUSTOMERS.FISCAL.FISCAL_ID" | translate }} *</label><input id="fiscalId"
              pInputText formControlName="fiscal_id" />
          </div>
          <div class="field col-12 lg:col-5">
            <label for="addressLine1">{{ "COMMON.ADDRESS" | translate }} *</label><input id="addressLine1" pInputText
              formControlName="address_line1" />
          </div>
          <div class="field col-12 lg:col-5">
            <label for="addressLine2">{{
              "ADMIN.CUSTOMERS.FISCAL.ADDRESS_2" | translate
              }}</label><input id="addressLine2" pInputText formControlName="address_line2" />
          </div>
          <div class="field col-12 lg:col-3">
            <label for="city">{{ "COMMON.CITY" | translate }} *</label><input id="city" pInputText
              formControlName="city" />
          </div>
          <div class="field col-12 lg:col-3">
            <label for="province">{{ "COMMON.PROVINCE" | translate }} *</label><input id="province" pInputText
              formControlName="province" />
          </div>
          <div class="field col-12 lg:col-2">
            <label for="postalCode">{{ "COMMON.POSTAL_CODE" | translate }} *</label><input id="postalCode" pInputText
              formControlName="postal_code" />
          </div>
          <div class="field col-12 lg:col-2">
            <label for="countryCode">{{ "COMMON.COUNTRY" | translate }} *</label><input id="countryCode" pInputText
              formControlName="country_code" />
          </div>
          <div class="field col-12 lg:col-8">
            <label for="billingNotes">{{
              "ADMIN.CUSTOMERS.FISCAL.BILLING_NOTES" | translate
              }}</label><input id="billingNotes" pInputText formControlName="billing_notes" class="w-full" />
          </div>
        </div>
      </section>
      }

      @if (currentStep === 4) {
      <section class="vc-admin-customer-signup__panel" formGroupName="admin">
        <h4>{{ "ADMIN.CUSTOMERS.WIZARD.STEP_4" | translate }}</h4>
        <div class="grid vc-admin-customer-signup__compact-grid">
          <div class="field col-12 lg:col-4">
            <label for="adminName">{{ "COMMON.NAME" | translate }} *</label><input id="adminName" pInputText
              formControlName="name" />
          </div>
          <div class="field col-12 lg:col-4">
            <label for="adminSurname">{{ "COMMON.SURNAME" | translate }} *</label><input id="adminSurname" pInputText
              formControlName="surname" />
          </div>
          <div class="field col-12 lg:col-4">
            <label for="adminEmail">{{ "COMMON.EMAIL" | translate }} *</label><input id="adminEmail" pInputText
              formControlName="email" />
          </div>
          <div class="field col-12 lg:col-4">
            <label for="adminLanguage">{{ "COMMON.LANGUAGE" | translate }} *</label>
            <p-select inputId="adminLanguage" formControlName="language" [options]="languageOptions" optionLabel="label"
              appendTo="body" optionValue="value" [showClear]="false"></p-select>
          </div>
        </div>
      </section>
      }

      @if (currentStep === 5) {
      <section class="vc-admin-customer-signup__panel" formGroupName="services">
        <h4>{{ "ADMIN.CUSTOMERS.WIZARD.STEP_5" | translate }}</h4>
        <div class="grid vc-admin-customer-signup__compact-grid">
          <div class="field col-12 lg:col-4">
            <label for="siteName">{{
              "ADMIN.CUSTOMERS.WIZARD.INITIAL_SITE_NAME" | translate
              }}
              *</label><input id="siteName" pInputText formControlName="initial_site_name" />
          </div>
          <div class="field col-12 lg:col-3">
            <label for="staffUsers">{{
              "ADMIN.SUBSCRIPTION.CONTRACTED_STAFF_USERS" | translate
              }}
              *</label><p-inputNumber inputId="staffUsers" formControlName="staff_users" [min]="1" [showButtons]="true"
              [step]="1" size="small"></p-inputNumber>
          </div>
          <div class="field col-12 lg:col-3">
            <label for="sites">{{
              "ADMIN.SUBSCRIPTION.CONTRACTED_SITES" | translate
              }}
              *</label><p-inputNumber inputId="sites" formControlName="sites" [min]="1" [showButtons]="true" [step]="1"
              size="small"></p-inputNumber>
          </div>
        </div>

        <div class="vc-admin-customer-signup__module-marketplace">
          <div class="vc-admin-customer-signup__module-head">
            <h5>{{ "ADMIN.CUSTOMERS.WIZARD.MODULES_TITLE" | translate }}</h5>
            <small>{{
              "ADMIN.CUSTOMERS.WIZARD.MODULES_HINT" | translate
              }}</small>
          </div>
          @if (moduleCards.length > 0) {
          <div class="vc-admin-customer-signup__module-grid">
            @for (module of moduleCards; track module.identifier) {
            <article class="vc-admin-customer-signup__module-card"
              [class.is-selected]="isModuleSelected(module.identifier)">
              <div>
                <h6>
                  {{ getModuleLabel(module.identifier, module.name) }}
                </h6>
                <p>
                  {{ module.monthly_price | number: "1.2-2" }} EUR /
                  {{ "ADMIN.SUBSCRIPTION.MONTH" | translate }}
                </p>
              </div>
              <button type="button" pButton size="small" [severity]="
                        isModuleSelected(module.identifier)
                          ? 'secondary'
                          : 'primary'
                      " [outlined]="isModuleSelected(module.identifier)" (click)="toggleModule(module.identifier)">
                {{
                isModuleSelected(module.identifier)
                ? ("COMMON.DISABLE" | translate)
                : ("COMMON.ENABLE" | translate)
                }}
              </button>
            </article>
            }
          </div>
          } @else {
          <p class="vc-admin-customer-signup__empty">
            {{ "COMMON.NO_RESULTS" | translate }}
          </p>
          }
        </div>
      </section>
      }
    </form>

    <ng-template pTemplate="footer">
      <div class="vc-admin-customer-signup__actions">
        @if (submitting) {
        <span class="vc-admin-customer-signup__submitting">
          <i class="pi pi-spin pi-spinner"></i>
          {{ "COMMON.LOADING" | translate }}...
        </span>
        }
        <button type="button" pButton severity="secondary" [outlined]="true" (click)="closeWizard()"
          [disabled]="submitting">
          {{ "COMMON.CANCEL" | translate }}
        </button>
        <button type="button" pButton severity="secondary" [outlined]="true" (click)="previousStep()"
          [disabled]="currentStep === 1 || submitting">
          {{ "COMMON.BACK" | translate }}
        </button>
        @if (currentStep < totalSteps) { <button type="button" pButton (click)="nextStep()" [disabled]="submitting">
          {{ "ADMIN.SUBSCRIPTION.WIZARD.NEXT" | translate }}
          </button>
          } @else {
          <button type="submit" pButton form="customerWizardForm" [disabled]="submitting" [loading]="submitting">
            {{ "ADMIN.CUSTOMERS.WIZARD.SUBMIT" | translate }}
          </button>
          }
      </div>
    </ng-template>
  </p-dialog>
</section>